import React from 'react';
import { getImageSource } from '../../common/lib/image-source';
import { categoryPill as c } from '../../component-classes';
import type { Image } from '../../types';

type CategoryPillProps = {
    className?: string;
    href: string;
    image?: Image;
    name: string;
    onClick?: (event: React.MouseEvent) => void;
};

function CategoryPill(props: CategoryPillProps) {
    const { className = '', href, image, name, onClick } = props;
    const imageSource =
        image &&
        getImageSource(image, { defaultResolution: 44, fallbackImage: '' });
    return (
        <a href={href} className={`${c.pill} ${className}`} onClick={onClick}>
            {imageSource?.src && (
                <img src={imageSource.src} className={c.icon} alt="" />
            )}
            <span className={c.text}>{name}</span>
        </a>
    );
}

export default CategoryPill;
